var _path, _circle, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSedan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 25,
    viewBox: "0 0 68 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.11134 20.1585C3.61134 20.0085 -0.908662 18.5385 1.01134 13.8585C2.82497 9.43774 9.30698 8.82878 13.1105 8.47145C14.3402 8.35592 15.29 8.2667 15.7114 8.08346C16.0733 7.92614 16.732 7.5365 17.6172 7.01298C20.9521 5.0406 27.5003 1.16779 33.4864 0.658458C44.0614 -0.241326 48.2614 0.658382 60.1114 5.60846C63.5314 5.84843 65.5864 6.75843 66.1864 7.18343V11.7584C67.1614 12.8834 68.4064 15.7334 65.5864 18.1334C62.6443 19.0565 60.8068 19.129 60.1808 19.0443C60.0296 15.8237 57.3706 13.259 54.1126 13.259C50.7575 13.259 48.0376 15.9789 48.0376 19.334C48.0376 19.6144 48.0566 19.8903 48.0934 20.1606L18.3364 20.5334L18.2194 20.5298C18.2965 20.1432 18.337 19.7434 18.337 19.334C18.337 15.9789 15.6171 13.259 12.262 13.259C8.90688 13.259 6.18701 15.9789 6.18701 19.334C6.18701 19.6151 6.20609 19.8916 6.24303 20.1625L6.11134 20.1585ZM25.6126 8.23382C25.1376 7.68382 24.0377 6.32889 24.3377 5.90889C24.7127 5.38389 31.0876 2.23395 37.6126 2.23389C37.3647 4.21719 36.9374 6.31996 36.6837 7.56879L36.6836 7.56908L36.6836 7.56929L36.6836 7.56932L36.6834 7.57004L36.6834 7.57018L36.6825 7.57466C36.6297 7.83452 36.5845 8.05718 36.55 8.23382H25.6126ZM39.562 2.08331L38.6494 8.0748L49.312 7.55831C49.312 6.43331 48.877 4.51331 47.437 3.43331C45.997 2.35331 41.612 1.88331 39.562 2.08331ZM51.7129 7.33345L49.0879 3.65845C50.9129 3.98345 54.5929 5.17345 54.7129 7.33345H51.7129Z",
    fill: "#BABABA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3383,
    cy: 19.4086,
    r: 4.05,
    stroke: "#BABABA",
    strokeWidth: 2.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.1879,
    cy: 19.4086,
    r: 4.05,
    stroke: "#BABABA",
    strokeWidth: 2.1
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSedan);
export default ForwardRef;